<!-- <span *ngIf="hideMe!=true" class="{{m_field.name}}-dynamic-class">
<mat-form-field class="custom-select demo-full-width margin-top" [formGroup]="group">
  <mat-select [placeholder]="m_field.label" [formControlName]="m_field.name" (selectionChange)="onChangeSelection($event)">
    <mat-option *ngFor="let item of options" [value]="item?.optionsLabel ? item?.optionsLabel : item">
      {{item?.optionsLabel ? item?.optionsLabel : item}}
    </mat-option>
  </mat-select>
</mat-form-field>
</span> -->

@if (hideMe!=true) {
  <span class="{{m_field.name}}-dynamic-class">
    <mat-form-field class="custom-select full-width" [formGroup]="group">
      <mat-label>{{m_field.label}}</mat-label>
      <mat-select [placeholder]="" [formControlName]="m_field.name" (selectionChange)="onChangeSelection($event)">
        @if (m_field.defaultOption) {
          <mat-option [value]="m_field.defaultOption?.value">
            {{m_field.defaultOption?.label}}
          </mat-option>
        }
        @for (item of options; track item) {
          <mat-option [value]="item?.optionValue ? item?.optionValue : item">
            {{item?.optionsLabel ? item?.optionsLabel : item}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </span>
}
